import { render } from "./nice-arrow.global.vue?vue&type=template&id=68d668d0"
import script from "./nice-arrow.global.vue?vue&type=script&lang=js"
export * from "./nice-arrow.global.vue?vue&type=script&lang=js"

import "./nice-arrow.global.vue?vue&type=style&index=0&id=68d668d0&lang=scss"
script.render = render

export default script